module.exports = __webpack_public_path__ + "static/22-5351dc28c4584a97df7259c1620fbffc.png";